export default __webpack_public_path__ + "static/media/SortAsc.db1b2424.svg";